import { IRatingSnippetsApiResult } from '../../../api/RatingsAndReviewsApiSdk';
import { TOTAL_NUMBER_OF_STARS } from '../../constants/PowerReviews';
import { computeRoundedValueFor } from '../../utils/ComputeRoundedValueFor';

export class ReviewSnippet {
    public pageId: string;
    public averageRating: number = 0;
    public reviewCount: number;
    public answeredQuestions: number;

    public static fromJson(data: IRatingSnippetsApiResult): ReviewSnippet {
        const reviewSnippet = new ReviewSnippet();
        reviewSnippet.pageId = data.page_id;
        reviewSnippet.averageRating = computeRoundedValueFor(data.rollup.average_rating || 0);
        reviewSnippet.reviewCount = data.rollup.review_count;
        reviewSnippet.answeredQuestions = data.rollup.answered_questions;

        return reviewSnippet;
    }

    public get reviewPercentage() {
        return (this.averageRating / TOTAL_NUMBER_OF_STARS) * 100;
    }
}
